import React from 'react'
import { useWatch } from 'react-hook-form'
import { useSelector } from 'react-redux'

//UI
import { Flex } from '@chakra-ui/react'

import BookingTabDocumentSection from './BookingTabDocumentSection'

import BookingTabApprovalSection from '@/features/offers/offer-detail/tabs/BookingTab/BookingTabApprovalSection'
import BookingTabSubSystemSection from './BookingTabSubSystemSection'
import BookingTabGeneralInfoSection from './BookingTabGeneralInfoSection'
import BookingTabHandoverFormSection from './BookingTabHandoverFormSection'

import config from '@/config'
// TODO: Add later — Major Commercial Highlights
// import { ContributorGroupType } from '@/features/contributorGroups/constants'
import CommercialChecklistCustomerRightSection from '@/features/offers/components/OfferForm/CommercialChecklistForm/CommercialChecklistCustomerRightSection'
import { OfferType } from '@/features/offers/constants'
import { offerBookingGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerBookingEditRights'
import { selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
import BookingTabCommercialSection from './BookingTabCommercialSection'
import BookingTabContractPriceSection from './BookingTabContractPriceSection'
// TODO: Add later — Major Commercial Highlights
// import BookingTabLegalSection from './BookingTabLegalSection'

const BookingTab = () => {
  const offerPermissions = useSelector(selectOfferPermissions)

  const mainOfferType = useWatch({ name: 'subSystems.0.type' })

  // TODO: Add later — Major Commercial Highlights
  // const bookingApproverDetails = useWatch({ name: `booking.approverDetails` }) ?? []

  //Translated Variable

  // TODO: Add later — Major Commercial Highlights
  // const hasLegal = bookingApproverDetails.some((approverDetail) => approverDetail.type === ContributorGroupType.LEGAL)
  const canEditBookingCommercialCustomerRight =
    offerPermissions[offerBookingGroupPolicyType.BOOKING_COMMERCIAL_CUSTOMER_RIGHTS]?.edit ?? false

  return (
    <Flex direction={'column'} gap="5">
      <BookingTabGeneralInfoSection />

      <BookingTabDocumentSection />

      {mainOfferType === OfferType.MAINTENANCE && (
        <CommercialChecklistCustomerRightSection isBooking isDisabled={!canEditBookingCommercialCustomerRight} />
      )}

      <BookingTabSubSystemSection />

      <BookingTabCommercialSection />

      <BookingTabContractPriceSection />

      {config.handoverFormEnabled && mainOfferType === OfferType.PROJECT && <BookingTabHandoverFormSection />}

      {/* TODO: Add later — Major Commercial Highlights */}
      {/* {hasLegal && <BookingTabLegalSection />} */}

      <BookingTabApprovalSection />
    </Flex>
  )
}

export default BookingTab
